export const isThirdPartyBlocked = () => {
  try {
    localStorage.setItem("CC_TEST", "CC_TEST");
    localStorage.removeItem("CC_TEST");
    return false;
  } catch (e) {
    return true;
  }
};
